import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { popupStore } from '@pascal/pascal-core';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { kenoGameConnection } from '../liveConnection/GameLiveConnection';
import { liveUpdateConnection } from '../liveConnection/LiveUpdateConnection';
import { useLostInternet } from '../../hooks/useLostInternet';
import { soundService } from '../baseSoundService';

export function SocketConnection() {
  const { pathname } = useLocation();

  const lostInternetConnection = useCallback(() => {
    popupStore.open({ name: PopUps.ConnectionError });
    popupStore.onConnectionError(true);
    soundService.muteMusic(true);
    soundService.muteSounds(true);
  }, []);

  const openConnection = useCallback(() => {
    kenoGameConnection.init().then(() => {
      kenoGameConnection.sendGameGetInitialState().then(() => {});
      liveUpdateConnection.getAllGameLiveBets().then(() => {});
    });
  }, []);

  useLostInternet(openConnection, lostInternetConnection);

  useEffect(() => {
    kenoGameConnection.init().then(() => {
      kenoGameConnection.sendGameGetInitialState().then(() => {});
    });
    liveUpdateConnection.init().then(() => {
      liveUpdateConnection.sendGetInitialState();
    });
  }, [pathname]);

  return <> </>;
}
